import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { applicationSteps } from '@/mocks/applicationData';

export default function ApplicationSteps() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('application.steps.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('application.steps.title')}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {t('application.steps.titleEn')}
          </p>
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto mb-6"></div>
          <p className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">
            {t('application.steps.lead')}
          </p>
        </div>

        <div className="space-y-0">
          {applicationSteps.map((step, idx) => (
            <div key={idx} className="relative flex gap-5">
              <div className="flex flex-col items-center flex-shrink-0">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/10">
                  <span className="text-accent-600 text-[13px] tracking-[0.08em] font-medium">{step.step}</span>
                </div>
                {idx < applicationSteps.length - 1 && (
                  <div className="w-[1px] flex-1 bg-accent-400/20 my-1"></div>
                )}
              </div>

              <div className={`pb-8 ${idx === applicationSteps.length - 1 ? 'pb-0' : ''}`}>
                <div className="card-glow bg-background-50 border border-background-200/60 p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className={`${step.icon} text-accent-500 text-base`}></i>
                    </div>
                    <div>
                      <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.05em]">
                        {lang === 'en' ? t(`application.step.${idx}.title`) : step.title}
                      </h3>
                      <p className="text-[12px] text-foreground-400 tracking-[0.08em] font-label">
                        {step.titleEn}
                      </p>
                    </div>
                    <div className="ml-auto">
                      {!step.required ? (
                        <span className="inline-block px-2 py-0.5 border border-foreground-300/30 text-[12px] text-foreground-400 tracking-[0.05em]">
                          {t('application.steps.optionalBadge')}
                        </span>
                      ) : (
                        <span className="inline-block px-2 py-0.5 border border-accent-500/30 text-[12px] text-accent-600 tracking-[0.05em]">
                          {t('application.steps.requiredBadge')}
                        </span>
                      )}
                    </div>
                  </div>
                  <p className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed">
                    {lang === 'en' ? t(`application.step.${idx}.desc`) : step.description}
                  </p>
                  {step.instruction && (
                    <p className="mt-3 text-[14px] text-accent-600 tracking-[0.04em]">
                      {'->'} {lang === 'en' ? t(`application.step.${idx}.instruction`) : step.instruction}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
